import OverflowText from './components/OverflowText.vue'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const { logoutLandingPath } = require('./utils/sessionNavigation.cjs')
import ElementUI from 'element-ui'
import LevelBackButton from './components/LevelBackButton.vue'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/tokens.css'
// 全局 Element-UI 暗化覆盖 —— 所有页面 / 所有 portal 弹窗自动套主题。
// ⚠ 必须放在 element-ui 官方 css 和 tokens.css 之后，由 CSS 加载顺序决定优先级。
// ⚠ 新页面/新组件不再需要重复写 .el-card / .el-table / .el-dialog 的暗化样式。
import './styles/element-dark.css'
// 共享自定义组件类 —— 大屏页面共用的 aimason-btn / filter-btn / time-btn 等
import './styles/components.css'
import './styles/commerce-light.css'
import permissionDirective from './directive/permission'
import * as echarts from 'echarts'
import { installChunkLoadRecovery } from './utils/chunkLoadRecovery.cjs'
import feedbackMessage from './utils/feedbackMessage'

// 全局注册 echarts
Vue.prototype.$echarts = echarts

// 全局组件尺寸统一 mini：el-button / el-input / el-form / el-table 等
// 没有显式指定 size 的实例都会取这里的默认值，避免 mini / small 混用
Vue.component('OverflowText', OverflowText)
Vue.use(ElementUI, { size: 'mini' })
Vue.component('LevelBackButton', LevelBackButton)
// 操作结果提示统一停留 2 秒；显式传入 duration 的业务场景仍按其自身配置。
Vue.prototype.$message = feedbackMessage
Vue.directive('permission', permissionDirective)

// 点击外部关闭指令
Vue.directive('click-outside', {
  bind(el, binding) {
    el._clickOutside = (e) => {
      if (!el.contains(e.target)) {
        binding.value()
      }
    }
    document.addEventListener('click', el._clickOutside, true)
  },
  unbind(el) {
    document.removeEventListener('click', el._clickOutside, true)
  }
})

/**
 * 全局权限校验方法：模板里用 v-if="$hasPerm('device:create')" 控制元素显示。
 * 和 v-permission 指令的区别：
 *   - v-permission 只在元素首次渲染时判断一次，不通过就从 DOM 移除（适合按钮）
 *   - $hasPerm 是 Vue 响应式计算，store.state.user.permissions 变化时会重新求值
 *     （适合嵌套 v-if、分组标题联动隐藏等场景）
 * 用法：
 *   v-if="$hasPerm('device:create')"          // 单个
 *   v-if="$hasPerm(['device:create', 'device:update'])" // 任一满足
 */
Vue.prototype.$hasPerm = function (code) {
  const perms = store.state.user.permissions || []
  if (perms.includes('*')) return true
  const required = Array.isArray(code) ? code : [code]
  return required.some(c => perms.includes(c))
}

// 同域页面共享一次登录；其他标签页退出或切换账号后立即刷新本页会话。
window.addEventListener('storage', event => {
  if (event.storageArea === localStorage && event.key === 'token' && event.newValue !== store.state.user.token) {
    if (!event.newValue) window.location.assign(logoutLandingPath(store.state.user))
    else window.location.reload()
  }
})

Vue.config.productionTip = false

// 已打开的旧版本页面在重新部署后可能继续请求已删除的懒加载分包。
// 首次遇到该类错误时自动刷新入口，切换到服务器当前版本；15 秒内不重复刷新。
installChunkLoadRecovery(router, window)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
